// ─── categorySlice.js ─────────────────────────────────────────────────

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAllCategories } from "../../services/api"; // ✅ wrong import, was using getProducts

export const fetchCategory = createAsyncThunk(
    "category/fetchCategory",
    async (slug, { rejectWithValue }) => {
        try {
            const response = await getAllCategories(slug); // ✅ correct api call
            // console.log(response);
            
            return {
                slug,
                data: response.data, // ✅ was [response.data](http://...) — markdown corruption
            };
        } catch (error) {
            return rejectWithValue(error.response?.data || "failed to fetch categories");
        }
    }
);

const categorySlice = createSlice({
    name: "categories",
    initialState: {
        categoryData: {},
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCategory.pending, (state) => {
                state.error = null;
            })
            .addCase(fetchCategory.fulfilled, (state, action) => {
                const { slug, data } = action.payload;
                state.categoryData[slug] = data;
            })
            .addCase(fetchCategory.rejected, (state, action) => {
                state.error = action.payload;
            });
    },
});

export default categorySlice.reducer;